import { useState } from "react";
import { Box } from "@mui/material";
import { Step1, Step2, Step3, Step4, Step5 } from "./components";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "components/Breadcrumb";
import { BREADCRUMB_PAGE } from "components/Breadcrumb/constants";
import { StepsLayoutContainer } from "components/Layout/StepsLayoutContainer";

export const FeedbackGuide = () => {
  const [requirements, setRequirements] = useState<any[]>([]);
  const navigate = useNavigate();

  const steps = [
    "Orient",
    "Prepare",
    "Perform",
    "Ask & Discuss",
    "Ask & Plan Together",
  ];

  const stepComponentList = [
    <Step1 />,
    <Step2
      requirements={requirements}
      onUpdateRequirements={(data) => {
        setRequirements(data);
      }}
    />,
    <Step3 requirements={requirements} />,
    <Step4 requirements={requirements} />,
    <Step5 />,
  ];

  return (
    <>
      <Box mb={2}>
        <Breadcrumb page={BREADCRUMB_PAGE.FEEDBACK_GUIDE} />
      </Box>
      <StepsLayoutContainer
        steps={steps}
        StepComponentList={stepComponentList}
        onComplete={() => {
          navigate("/home");
        }}
      />
    </>
  );
};
